import React from 'react';

import { FormattedMessage } from '../../util/reactIntl';

import css from './SectionHighlights.module.css';

const iconProps = {
  width: 24,
  height: 24,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
};

const ICONS = {
  access24h: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <polyline points="12 7 12 12 15 14" />
    </svg>
  ),
  wifi: (
    <svg {...iconProps}>
      <path d="M5 12.55a11 11 0 0 1 14 0" />
      <path d="M2 8.82a16 16 0 0 1 20 0" />
      <path d="M8.5 16.43a6 6 0 0 1 7 0" />
      <line x1="12" y1="20" x2="12.01" y2="20" />
    </svg>
  ),
  meetingroom: (
    <svg {...iconProps}>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="9" y1="14" x2="15" y2="14" />
    </svg>
  ),
  coffee: (
    <svg {...iconProps}>
      <path d="M18 8h1a3 3 0 0 1 0 6h-1" />
      <path d="M3 8h15v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4z" />
      <line x1="6" y1="2" x2="6" y2="5" />
      <line x1="10" y1="2" x2="10" y2="5" />
      <line x1="14" y1="2" x2="14" y2="5" />
    </svg>
  ),
  parking: (
    <svg {...iconProps}>
      <rect x="4" y="4" width="16" height="16" rx="2" />
      <path d="M10 17V8h3.5a2.5 2.5 0 0 1 0 5H10" />
    </svg>
  ),
  verified: (
    <svg {...iconProps}>
      <path d="M12 2 4 5v6c0 5 3.5 9 8 11 4.5-2 8-6 8-11V5z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  ),
  dot: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="3" fill="currentColor" />
    </svg>
  ),
};

const Icon = ({ iconKey }) => ICONS[iconKey] || ICONS.dot;

/**
 * Renders up to 3 stacked highlight rows. Each row: icon left, title + description right.
 *
 * Props:
 *   - highlights: Array<{ iconKey: string, titleId: string, descId: string }>
 */
const SectionHighlights = props => {
  const { highlights } = props;

  if (!Array.isArray(highlights) || highlights.length === 0) {
    return null;
  }

  const rows = highlights.slice(0, 3);

  return (
    <section className={css.root}>
      <ul className={css.list}>
        {rows.map((h, idx) => (
          <li key={`${h.iconKey}-${idx}`} className={css.row}>
            <span className={css.iconWrap}>
              <Icon iconKey={h.iconKey} />
            </span>
            <span className={css.text}>
              <span className={css.title}>
                <FormattedMessage id={h.titleId} />
              </span>
              <span className={css.desc}>
                <FormattedMessage id={h.descId} />
              </span>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default SectionHighlights;
